// import React, { useState } from 'react';
// import VoiceCore from './VoiceCore';
// import { FaMicrophone, FaStop } from 'react-icons/fa';

// export default function TalkingBot() {
//   const [isSpeaking, setIsSpeaking] = useState(false);
//   const [isListening, setIsListening] = useState(false);

// const apiKey = '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';
//  console.log("Checking API Key:", apiKey ? "Key Loaded" : "KEY IS UNDEFINED");

//   const startVoiceInteraction = () => {
//     const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
//     recognition.onstart = () => setIsListening(true);
//     recognition.onresult = async (event) => {
//       setIsListening(false);
//       const userText = event.results[0][0].transcript;

//       // Send to Groq API
//       const response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
//         method: "POST",
//         headers: { "Authorization": `Bearer ${apiKey}`, "Content-Type": "application/json" },
//         body: JSON.stringify({
//           model: "llama-3.1-8b-instant",
//           messages: [{ role: "user", content: userText }]
//         })
//       });
//       const data = await response.json();
//       const aiReply = data.choices[0].message.content;

//       // Speak back
//       const speech = new SpeechSynthesisUtterance(aiReply);
//       speech.onstart = () => setIsSpeaking(true);
//       speech.onend = () => setIsSpeaking(false);
//       window.speechSynthesis.speak(speech);
//     };
//     recognition.start();
//   };

//   return (
//     <div className="live-demo-card">
//       <VoiceCore isSpeaking={isSpeaking || isListening} />
//       <button className="btn-primary" onClick={startVoiceInteraction}>
//         {isListening ? "Listening..." : "Talk to Hanna"}
//       </button>
//     </div>
//   );
// }
// -------------------------

// import React, { useState } from 'react';
// import { FaMicrophone, FaPhoneSlash, FaMicrophoneSlash } from 'react-icons/fa';
// import './aibot.css';

// export default function TalkingBot() {
//   const [state, setState] = useState('idle'); // idle, listening, speaking

//   const startCall = () => {
//     setState('listening');
//     const rec = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
//     rec.onresult = async (e) => {
//       setState('speaking');
//       // Simulated AI response logic
//       const speech = new SpeechSynthesisUtterance("Hello! I am Hanna. How can I help you today?");
//       speech.onend = () => setState('idle');
//       window.speechSynthesis.speak(speech);
//     };
//     rec.start();
//   };

//   return (
//     <div className="live-demo-card">
//       <div className={`ai-gif-container ${state}`}>
//         <img
//           src={state === 'speaking'
//             ? "https://i.pinimg.com/originals/19/e4/21/19e421ce92a12f4bfdc1171abb28486c.gif"
//             : "https://i.pinimg.com/originals/19/e4/21/19e421ce92a12f4bfdc1171abb28486c.gif"}
//           alt="AI Agent"
//           className="ai-gif"
//         />
//         {state === 'listening' && <div className="listening-ring"></div>}
//       </div>

//       {state === 'idle' ? (
//         <button className="btn-primary" onClick={startCall}>Start Voice Demo</button>
//       ) : (
//         <div className="call-controls">
//           <button className="control-btn" onClick={() => window.speechSynthesis.cancel()}><FaMicrophoneSlash /> </button>
//           <button className="control-btn end-call" onClick={() => { setState('idle'); window.speechSynthesis.cancel(); }}><FaPhoneSlash /> </button>
//         </div>
//       )}
//     </div>
//   );
// }

// -------------------

// import React, { useState, useEffect, useRef } from 'react';
// import { FaPhoneSlash, FaMicrophoneSlash } from 'react-icons/fa';
// import './voicebot.css';

// export default function TalkingBot() {
//   const [state, setState] = useState('idle'); // idle, listening, speaking
//   // const recognition = useRef(null);
//   const recognitionRef = useRef(null);

//   const apiKey = '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';
//  console.log("Checking API Key:", apiKey ? "Key Loaded" : "KEY IS UNDEFINED");

//   useEffect(() => {
//     const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
//     recognitionRef.current = new SpeechRecognition();

//     recognitionRef.current.onresult = (event) => {
//       const transcript = event.results?.[event.resultIndex]?.[0]?.transcript;
//       if (transcript) processUserIntent(transcript);
//     };

//     // Crucial: Handle errors so the app doesn't crash
//     recognitionRef.current.onerror = (event) => {
//       console.log("Recognition error:", event.error);
//       setState('idle');
//     };
//   }, []); // Empty dependency array ensures this runs once

//   const startConversation = () => {
//     setState('speaking');
//     const greeting = new SpeechSynthesisUtterance("Hello, I am Hanna. Which of our AI agent services would you like to explore today?");

//     // When greeting finishes, start listening IMMEDIATELY
//     greeting.onend = () => {
//       setState('listening');
//       recognitionRef.current.start();
//     };

//     window.speechSynthesis.speak(greeting);
//   };

//   const processUserIntent = async (userText) => {
//     setState('speaking');
//     window.speechSynthesis.cancel(); // Stop bot if user started speaking

//     const response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
//       method: "POST",
//       headers: { "Authorization": "Bearer ${apiKey}", "Content-Type": "application/json" },
//       body: JSON.stringify({
//         model: "llama-3.1-8b-instant",
//         messages: [
//           { role: "system", content: "You are Hanna. Keep answers very short. Talk ONLY about Cyfrowy.ai services. After speaking, wait for user." },
//           { role: "user", content: userText }
//         ]
//       })
//     });

//     const data = await response.json();
//     const aiReply = data.choices[0].message.content;

//     const utterance = new SpeechSynthesisUtterance(aiReply);
//     utterance.onend = () => {
//       setState('listening');
//       recognitionRef.current.start(); // RE-START listening loop
//     };
//     window.speechSynthesis.speak(utterance);
//   };

//   return (
//     <div className="live-demo-card">
//       {/* Clicking the orb triggers the conversation */}
//       <div className={`ai-gif-container ${state}`} onClick={state === 'idle' ? startConversation : null}>
//         <img src="https://mir-s3-cdn-cf.behance.net/project_modules/hd/f4020f114494633.603cbcc781296.gif" className="ai-gif" />
//       </div>

//       {state !== 'idle' && (
//         <div className="call-controls">
//           <button className="btn-add" onClick={() => {
//             setState('idle');
//             window.speechSynthesis.cancel();
//             recognitionRef.current.stop();
//           }}><FaPhoneSlash /> End Call</button>
//         </div>
//       )}
//     </div>
//   );
// }

// ------------------

// import React, { useState, useEffect, useRef } from "react";
// import { FaPhoneSlash, FaMicrophoneSlash, FaSpinner } from "react-icons/fa";
// import "./voicebot.css";

// export default function TalkingBot() {
//   const [state, setState] = useState("idle");
//   const recognitionRef = useRef(null);

//   const apiKey = "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";
//   console.log("Checking API Key:", apiKey ? "Key Loaded" : "KEY IS UNDEFINED");
//   useEffect(() => {
//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (SpeechRecognition) {
//       recognitionRef.current = new SpeechRecognition();
//       recognitionRef.current.continuous = false;
//       recognitionRef.current.interimResults = false;

//       recognitionRef.current.onresult = (event) => {
//         const transcript = event.results?.[0]?.[0]?.transcript;
//         if (transcript) processUserIntent(transcript);
//       };

//       recognitionRef.current.onerror = (e) => {
//         console.error("Speech Error:", e.error);
//         setState("idle");
//       };
//     }
//   }, []);

//   const processUserIntent = async (userText) => {
//     setState("speaking");
//     window.speechSynthesis.cancel();

//     // 1. Clean the API key (trim removes hidden spaces/newlines)
//     const rawKey = "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";
//     const apiKey = rawKey.trim();

//     try {
//       const response = await fetch(
//         "https://api.groq.com/openai/v1/chat/completions",
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${apiKey}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             model: "llama-3.1-8b-instant",
//             messages: [
//               {
//                 role: "system",
//                 content: `You are Hanna, the official AI Consultant for Cyfrowy.ai (pronounced: Sif-rov-ee dot A I).
//               ALWAYS use the name Cyfrowy.ai. NEVER use any other name.

//               YOUR SERVICES:
//  1. HR Agents: "HR Helpdesk", "Hiring Assistant", "Performance Review",
//   2. Marketing Agents: "Content Creation", "Social Media Agent", "Ebook Generator",
//   3. Sales Agents: "AI SDR Agent", "Phone Dialer", "Proposal Writer",
//   4. Banking Agents: "KYC Compliance", "Fraud Detection", "Loan Origination",
//   5. Insurance Agents: "Policy Underwriting", "Claims Processing", "Claims Analysis",
//   6. Others Agents: "RFP Creation", "IT Helpdesk", "Cloud Cost Analyzer"
//   7. Real Estate Agents: "Property Valuation", "Tenant Screening", "Lease Management",

//               INSTRUCTIONS:
//               - Only recommend these specific services.
//               - If a user asks about services, list them clearly.
//               - Keep answers short, professional, and under 20 words.
//               - If you don't know the service, politely ask for clarification within our catalog.`,
//               },
//               { role: "user", content: userText },
//             ],
//           }),
//         },
//       );

//       // 2. Immediate 401 Check
//       if (response.status === 401) {
//         throw new Error("UNAUTHORIZED_KEY");
//       }

//       const data = await response.json();

//       const aiReply =
//         data?.choices?.[0]?.message?.content ||
//         "I am ready to help with your Cyfrowy.ai agents.";
//       // Before window.speechSynthesis.speak(utterance);
//       const utterance = new SpeechSynthesisUtterance(aiReply);
//       utterance.rate = 0.95; // Slightly slower makes it sound more professional/human
//       utterance.pitch = 1.0;
//       // Try to find a high-quality voice
//       const voices = window.speechSynthesis.getVoices();
//       // Look for a high-quality English voice
//       utterance.voice =
//         voices.find((v) => v.name.includes("Google US English")) || voices[0];

//       // 3. Robust check for data
//       if (data?.choices?.[0]?.message?.content) {
//         const aiReply = data.choices[0].message.content;
//         const utterance = new SpeechSynthesisUtterance(aiReply);

//         utterance.onend = () => {
//           setState("listening");
//           recognitionRef.current?.start();
//         };

//         window.speechSynthesis.speak(utterance);
//       } else {
//         throw new Error("EMPTY_RESPONSE");
//       }
//     } catch (e) {
//       console.error("Critical Bot Error:", e.message);
//       setState("idle");

//       const errorMessage =
//         e.message === "UNAUTHORIZED_KEY"
//           ? "My access key is invalid. Please update the API key."
//           : "I am having a temporary sync error.";

//       const errUtterance = new SpeechSynthesisUtterance(errorMessage);
//       window.speechSynthesis.speak(errUtterance);
//     }
//   };

//   const startConversation = () => {
//     setState("speaking");
//     const greeting = new SpeechSynthesisUtterance(
//       "Hello! I am Hanna Senior Consultant for Sif-rov-ee.AI. Which AI agent can I help you deploy today?",
//     );
//     greeting.onend = () => {
//       setState("listening");
//       recognitionRef.current?.start();
//     };
//     window.speechSynthesis.speak(greeting);
//   };

//   return (
//     <div className="live-demo-card">
//       <div
//         className={`ai-gif-container ${state}`}
//         onClick={state === "idle" ? startConversation : null}
//       >
//         <img
//           src="https://miro.medium.com/v2/resize:fit:1200/1*wX8RI80-FKhbP0ODlQrEQw.gif"
//           className="ai-gif"
//           alt="Hanna"
//         />
//       </div>

//       {state !== "idle" && (
//         <div className="call-controls">
//           <button
//             className="btn-add"
//             onClick={() => window.speechSynthesis.cancel()}
//           >
//             <FaMicrophoneSlash /> Mute
//           </button>
//           <button
//             className="btn-add end-call"
//             onClick={() => {
//               setState("idle");
//               window.speechSynthesis.cancel();
//               recognitionRef.current?.stop();
//             }}
//           >
//             <FaPhoneSlash /> End
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

// ----------------------

// import React, { useState, useEffect, useRef } from 'react';
// import { FaPhoneSlash } from 'react-icons/fa';
// import './voicebot.css';

// export default function TalkingBot() {
//   const [state, setState] = useState('idle');
//   const recognitionRef = useRef(null);
//   const synth = window.speechSynthesis;

// const isListeningRef = useRef(false); // Track internal state

// const startRecognition = () => {
//   if (recognitionRef.current && !isListeningRef.current) {
//     try {
//       recognitionRef.current.start();
//       isListeningRef.current = true;
//     } catch (e) {
//       console.log("Recognition already active");
//     }
//   }
// };

// const stopRecognition = () => {
//   if (recognitionRef.current && isListeningRef.current) {
//     recognitionRef.current.stop();
//     isListeningRef.current = false;
//   }
// };

//   useEffect(() => {
//     const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (SpeechRecognition) {
//       recognitionRef.current = new SpeechRecognition();
//       recognitionRef.current.continuous = true; // Stay on
//       recognitionRef.current.interimResults = false;

//       // Handle the "already started" error gracefully
//       recognitionRef.current.onerror = (e) => {
//         if (e.error === 'no-speech') return; // Silence is fine
//         console.log("Recognition error:", e.error);
//       };

//       recognitionRef.current.onresult = (e) => {
//         const transcript = e.results[e.results.length - 1][0].transcript;
//         processUserIntent(transcript);
//       };
//     }
//   }, []);

//   const startConversation = () => {
//     // Check if instance exists and is NOT already running
//     if (recognitionRef.current) {
//       try {
//         setState('listening');
//         recognitionRef.current.start();
//       } catch (e) {
//         // If it's already running, just ignore the error
//         console.log("Recognition already running, continuing...");
//       }
//     }

//     // AI Greeting
//     // const greeting = new SpeechSynthesisUtterance("Hello, I am Hanna from cyfrowy.ai . How can I assist you?");
//     const greeting = new SpeechSynthesisUtterance("Hello, I am Hanna from Sif-rov-e dot AI. How can I assist you?");
//     window.speechSynthesis.speak(greeting);
//   };

//   const processUserIntent = async (userText) => {
//     // BARGE-IN: Stop everything
//     synth.cancel();
//     setState('speaking');

//     try {
//       const response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
//         method: "POST",
//         headers: {
//           "Authorization": "Bearer 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",
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           // model: "openai/gpt-oss-120b",
//           model: "llama-3.1-8b-instant",
//           messages: [
//             { role: "system", content: "You are Hanna from Cyfrowy dot A I. Keep answers under 15 words. If interrupted, stop instantly. Answer only based on our services." },
//              {
//                 role: "system",
//                 content: `You are Hanna, the official AI Consultant for Sif-rov-e dot AI (pronounced: Sif-rov-e dot A I).
//               ALWAYS use the name Sif-rov-ee dot A I. NEVER use any other name.

//               INSTRUCTIONS:
//               -  If the user interrupts, stop speaking instantly.
//               - Respond to the user's interruption immediately.
//               - Only recommend these specific services.
//               - If a user asks about services, list them clearly.
//               - Keep answers short, professional, and under 15 words.
//               - Focus only on Sif-rov-ee dot A I services.
//               - If you don't know the service, politely ask for clarification within our catalog.

//               YOUR SERVICES:
//             1. HR Agents: "HR Helpdesk", "Hiring Assistant", "Performance Review",
//             2. Marketing Agents: "Content Creation", "Social Media Agent", "Ebook Generator",
//             3. Sales Agents: "AI SDR Agent", "Phone Dialer", "Proposal Writer",
//             4. Banking Agents: "KYC Compliance", "Fraud Detection", "Loan Origination",
//             5. Insurance Agents: "Policy Underwriting", "Claims Processing", "Claims Analysis",
//             6. Others Agents: "RFP Creation", "IT Helpdesk", "Cloud Cost Analyzer"
//             7. Real Estate Agents: "Property Valuation", "Tenant Screening", "Lease Management",

//               `,
//               },

//             { role: "user", content: userText }
//           ]
//         })
//       });

//       const data = await response.json();
//       const reply = data.choices[0].message.content;

//       const utterance = new SpeechSynthesisUtterance(reply);

//     utterance.onend = () => {
//         setState('listening');
//       };

//       synth.speak(utterance);
//     } catch (e) {
//       console.error(e);
//       setState('listening'); // Just set state back to listening
//     }
//   };

//   // const startConversation = () => {
//   //   setState('speaking');
//   //   const greeting = new SpeechSynthesisUtterance("Hello, I am Hanna from Sif-rov-ee.AI. How can I assist you?");
//   //   greeting.onend = () => {
//   //     setState('listening');
//   //     recognitionRef.current.start();
//   //   };
//   //   synth.speak(greeting);
//   // };

//   return (
//     <div className="live-demo-card">
//       <div className={`ai-gif-container ${state}`} onClick={state === 'idle' ? startConversation : null}>
//         <img src="https://miro.medium.com/v2/resize:fit:1200/1*wX8RI80-FKhbP0ODlQrEQw.gif" className="ai-gif" alt="Hanna" />
//       </div>

//       {state !== 'idle' && (
//         <div className="call-controls">
//           <button  className="btn-add end-call" onClick={() => {
//             setState('idle');
//             synth.cancel();
//             recognitionRef.current.stop();
//           }}><FaPhoneSlash /> End Call</button>
//         </div>
//       )}
//     </div>
//   );
// }

// -------------------- ok with error

// import React, { useState, useEffect, useRef } from 'react';
// import { FaPhoneSlash } from 'react-icons/fa';
// import './voicebot.css';

// export default function TalkingBot() {
//   const [state, setState] = useState('idle');
//   const recognitionRef = useRef(null);
//   const synth = window.speechSynthesis;

//   useEffect(() => {
//     const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (SpeechRecognition) {
//       recognitionRef.current = new SpeechRecognition();
//       recognitionRef.current.continuous = true; // Essential for barge-in
//       recognitionRef.current.interimResults = false;

//       // --- THE BARGE-IN FIX ---
//       // This fires the instant the user makes any sound.
//       recognitionRef.current.onsoundstart = () => {
//         if (synth.speaking) {
//           synth.cancel(); // Silences the AI instantly
//           setState('listening'); // Updates the UI ring
//         }
//       };

//       recognitionRef.current.onresult = (e) => {
//         const transcript = e.results[e.results.length - 1][0].transcript;
//         if (transcript) processUserIntent(transcript);
//       };

//       recognitionRef.current.onerror = (e) => {
//         if (e.error !== 'no-speech') console.log("Recognition error:", e.error);
//       };
//     }
//   }, []);

//   const processUserIntent = async (userText) => {
//     setState('speaking');

//     try {
//       const response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
//         method: "POST",
//         headers: {
//           "Authorization": "Bearer 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",
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           model: "llama-3.1-8b-instant",
//           messages: [
//             { role: "system", content: `You are Hanna, the official AI Consultant for Sif-rov-e dot AI. Pronounced: Sif-rov-ee dot A I.
//             Rules: Keep answers under 20 words. If interrupted, stop instantly. Focus only on Cyfrowy.ai services (  1. HR Agents: "HR Helpdesk", "Hiring Assistant", "Performance Review",
//             2. Marketing Agents: "Content Creation", "Social Media Agent", "Ebook Generator",
//             3. Sales Agents: "AI SDR Agent", "Phone Dialer", "Proposal Writer",
//             4. Banking Agents: "KYC Compliance", "Fraud Detection", "Loan Origination",
//             5. Insurance Agents: "Policy Underwriting", "Claims Processing", "Claims Analysis",
//             6. Others Agents: "RFP Creation", "IT Helpdesk", "Cloud Cost Analyzer"
//             7. Real Estate Agents: "Property Valuation", "Tenant Screening", "Lease Management",).` },
//             { role: "user", content: userText }
//           ]
//         })
//       });

//       const data = await response.json();
//       const reply = data.choices[0].message.content.replace(/Cyfrowy\.ai/gi, "Sif-ROV-ee dot A I");

//       const utterance = new SpeechSynthesisUtterance(reply);
//       synth.speak(utterance);
//     } catch (e) {
//       console.error(e);
//       setState('listening');
//     }
//   };

//   const startConversation = () => {
//     setState('listening');
//     try {
//       recognitionRef.current.start();
//     } catch (e) { console.log("Mic already active"); }

//     const greeting = new SpeechSynthesisUtterance("Hello, I am Hanna from Sif-rov-ee dot A I. How can I assist you with our services?");
//     synth.speak(greeting);
//   };

//   return (
//     <div className="live-demo-card">
//       <div className={`ai-gif-container ${state}`} onClick={state === 'idle' ? startConversation : null}>
//         <img src="https://miro.medium.com/v2/resize:fit:1200/1*wX8RI80-FKhbP0ODlQrEQw.gif" className="ai-gif" alt="Hanna" />
//       </div>

//       {state !== 'idle' && (
//         <div className="call-controls">
//           <button className="btn-add end-call" onClick={() => {
//             setState('idle');
//             synth.cancel();
//             recognitionRef.current.stop();
//           }}><FaPhoneSlash /> End Call</button>
//         </div>
//       )}
//     </div>
//   );
// }

// ---------------------

// import React, { useState, useEffect, useRef } from 'react';
// import { FaPhoneSlash } from 'react-icons/fa';
// import './voicebot.css';

// export default function TalkingBot() {
//   const [state, setState] = useState('idle');
//   const recognitionRef = useRef(null);
//   const synth = window.speechSynthesis;

// const audioContextRef = useRef(null);
//   const analyserRef = useRef(null);

// //  // Track history to maintain conversation context
// //   const conversationRef = useRef([
// //     { role: "system", content: "You are Hanna from Sif-rov-e dot AI. Keep answers under 15 words. Focus only on our services. If interrupted, stop instantly and respond to the interruption." }
// //   ]);

//   // Initialize Speech Recognition
//   const initRecognition = () => {
//     const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
//     recognitionRef.current = new SpeechRecognition();
//     recognitionRef.current.continuous = true;
//     recognitionRef.current.interimResults = false;

//     // INTERRUPTION LOGIC
//     recognitionRef.current.onsoundstart = () => {
//       if (synth.speaking) {
//         synth.cancel(); // 1. Stop speaking immediately
//         setState('listening');
//         console.log("Interruption detected");
//       }
//     };

//    recognitionRef.current.onresult = (e) => {
//         const transcript = e.results[e.results.length - 1][0].transcript;
//         if (transcript) processUserIntent(transcript);
//       };

//     // HARD RESET on error (Fixes the "Hang" after multiple turns)
//     recognitionRef.current.onerror = (e) => {
//       console.log("Recognition error, resetting...", e.error);
//       recognitionRef.current.stop();
//       setTimeout(() => recognitionRef.current.start(), 1000);
//     };

// //   // Optional: Visualize audio input (for debugging)
// // 1. Setup Audio Volume Monitor (VAD)
//     navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
//       audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
//       const source = audioContextRef.current.createMediaStreamSource(stream);
//       analyserRef.current = audioContextRef.current.createAnalyser();
//       source.connect(analyserRef.current);
//       analyserRef.current.fftSize = 256;

//       const bufferLength = analyserRef.current.frequencyBinCount;
//       const dataArray = new Uint8Array(bufferLength);

//       const checkVolume = () => {
//         analyserRef.current.getByteFrequencyData(dataArray);
//         let sum = 0;
//         for(let i = 0; i < bufferLength; i++) sum += dataArray[i];
//         const average = sum / bufferLength;

//         // If AI is speaking AND user volume > threshold (Barge-in triggered)
//         if (synth.speaking && average > 20) { // 20 is the sensitivity threshold
//           synth.cancel();
//           setState('listening');
//           console.log("Interruption by volume detected!");
//         }
//         requestAnimationFrame(checkVolume);
//       };
//       checkVolume();
//     });

//   };

//   useEffect(() => {
//     initRecognition();
//     return () => synth.cancel();
//   }, []);

//   const processUserIntent = async (userText) => {
//     setState('speaking');

//     //  // 1. BARGE-IN: If AI is talking, stop it immediately
//     // if (synth.speaking) {
//     //   synth.cancel();
//     // }

//     // setState('speaking');

//     // // 2. Update Conversation History
//     // const updatedHistory = [...conversationRef.current, { role: "user", content: userText }];
//     // conversationRef.current = updatedHistory;

//     try {
//       const response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
//         method: "POST",
//         headers: {
//           "Authorization": "Bearer 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",
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           model: "llama-3.1-8b-instant",
//           messages: [
//             { role: "assistant", content: `You are Hanna. Keep answers under 15 words. Focus on Cyfrowy.ai (Sif-rov-e dot AI) services. STOP speaking if interrupted.

//               rules:  Start with a greeting, then wait for user input. If user asks about services, list them clearly. Always use the name Cyfrowy.ai. NEVER use any other name. before ending, ask contact info for follow-up support. and end with greeting. ALWAYS follow the professional tone.

//               OUR SERVICES:
//             1. HR Agents: "HR Helpdesk", "Hiring Assistant", "Performance Review",
//             2. Marketing Agents: "Content Creation", "Social Media Agent", "Ebook Generator",
//             3. Sales Agents: "AI SDR Agent", "Phone Dialer", "Proposal Writer",
//             4. Banking Agents: "KYC Compliance", "Fraud Detection", "Loan Origination",
//             5. Insurance Agents: "Policy Underwriting", "Claims Processing", "Claims Analysis",
//             6. Others Agents: "RFP Creation", "IT Helpdesk", "Cloud Cost Analyzer"
//             7. Real Estate Agents: "Property Valuation", "Tenant Screening", "Lease Management",

//               ` },
//             { role: "user", content: userText }
//           ]
//         })
//       });

//       const data = await response.json();
//       const reply = data.choices[0].message.content.replace(/Cyfrowy\.ai/gi, "Sif-ROV-e dot A I");

//         // Update history with AI response
//       // conversationRef.current = [...updatedHistory, { role: "assistant", content: reply }];

//       const utterance = new SpeechSynthesisUtterance(reply);

//       // Force the agent to be active again immediately
//       utterance.onend = () => setState('listening');

//       synth.speak(utterance);
//     } catch (e) {
//       console.error(e);
//       setState('listening');
//     }
//   };

//   const startCall = () => {
//     setState('speaking');
//     try { recognitionRef.current.start(); } catch(e) {}
//     const greeting = new SpeechSynthesisUtterance("Hello, I am Hanna from Sif-rov-e dot A I. How can I assist you?");
//     greeting.onend = () => setState('listening');
//     synth.speak(greeting);
//   };

//   return (
//     <div className="live-demo-card">
//       <div className={`ai-gif-container ${state}`} onClick={state === 'idle' ? startCall : null}>
//         <img src="https://miro.medium.com/v2/resize:fit:1200/1*wX8RI80-FKhbP0ODlQrEQw.gif" className="ai-gif" alt="Hanna" />
//       </div>

//       {state !== 'idle' && (
//         <button className="btn-add end-call" onClick={() => {
//           setState('idle');
//           synth.cancel();
//           recognitionRef.current?.stop();
//         }}><FaPhoneSlash /> End Call</button>
//       )}
//     </div>
//   );
// }

// ------------------ working ok

// import React, { useState, useEffect, useRef } from "react";
// import { FaPhoneSlash } from "react-icons/fa";
// import "./voicebot.css";

// export default function TalkingBot() {
//   const [state, setState] = useState("idle");
//   const recognitionRef = useRef(null);
//   const synth = window.speechSynthesis;
//   // PERSISTENT HISTORY: This keeps the AI smart for the whole call
//   const historyRef = useRef([
//     {
//       role: "system",
//       content: `You are Hanna. Keep answers under 15 words. Focus on Cyfrowy.ai (Sif-rov-e dot AI) services. STOP speaking if interrupted.
             
//               rules:  Start with a greeting, then wait for user input. If user asks about services, list them clearly. Always use the name Cyfrowy.ai. NEVER use any other name. NEVER talk about anything else outside of Cyfrowy.ai services. before ending, ask contact info for follow-up support. and end with greeting. ALWAYS follow the professional tone.
              
//               OUR SERVICES:
//             1. HR Agents: "HR Helpdesk", "Hiring Assistant", "Performance Review",
//             2. Marketing Agents: "Content Creation", "Social Media Agent", "Ebook Generator",
//             3. Sales Agents: "AI telecaller Agent", "Phone Dialer", "Proposal Writer",
//             4. Banking Agents: "KYC Compliance", "Fraud Detection", "Loan Origination",
//             5. Insurance Agents: "Policy Underwriting", "Claims Processing", "Claims Analysis",
//             6. Others Agents: "RFP Creation", "IT Helpdesk", "Cloud Cost Analyzer"
//             7. Real Estate Agents: "Property Valuation", "Tenant Screening", "Lease Management",

//               `,
//     },
//   ]);

//   const initRecognition = () => {
//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     recognitionRef.current = new SpeechRecognition();
//     recognitionRef.current.continuous = true;
//     recognitionRef.current.interimResults = false;

//     recognitionRef.current.onresult = (e) => {
//       const transcript = e.results[e.results.length - 1][0].transcript;
//       processUserIntent(transcript);
//     };

//     recognitionRef.current.onerror = (e) => {
//       console.warn("Recognition error, restarting...", e.error);
//       recognitionRef.current.stop();
//       setTimeout(() => recognitionRef.current.start(), 500); // Auto-heal
//     };
//   };

//   useEffect(() => {
//     initRecognition();
//     return () => {
//       synth.cancel();
//       recognitionRef.current?.stop();
//     };
//   }, []);

//   const processUserIntent = async (userText) => {
//     synth.cancel(); // Stop talking instantly (Barge-in)
//     setState("speaking");

//     // Add to history
//     historyRef.current.push({ role: "user", content: userText });

//     try {
//       const response = await fetch(
//         "https://api.groq.com/openai/v1/chat/completions",
//         {
//           method: "POST",
//           headers: {
//             Authorization:
//               "Bearer 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",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             model: "llama-3.1-8b-instant",
//             messages: historyRef.current,
//           }),
//         },
//       );

//       const data = await response.json();
//       const reply = data.choices[0].message.content.replace(
//         /Cyfrowy\.ai/gi,
//         "Sif-rov-e dot AI",
//       );

//       historyRef.current.push({ role: "assistant", content: reply });

//       const utterance = new SpeechSynthesisUtterance(reply);
//       utterance.onend = () => setState("listening");
//       synth.speak(utterance);
//     } catch (e) {
//       console.error(e);
//       setState("listening");
//     }
//   };

//   const startCall = () => {
//     setState("listening");
//     try {
//       recognitionRef.current.start();
//     } catch (e) {}
//     const greeting = new SpeechSynthesisUtterance(
//       "Hello, I am Hanna from Sif-rov-e dot AI. How can I assist you with our services today?",
//     );
//     synth.speak(greeting);
//   };

//   return (
//     <div className="live-demo-card">
//       <div
//         className={`ai-gif-container ${state}`}
//         onClick={state === "idle" ? startCall : null}
//       >
//         <img
//           src="https://miro.medium.com/v2/resize:fit:1200/1*wX8RI80-FKhbP0ODlQrEQw.gif"
//           className="ai-gif"
//           alt="Hanna"
//         />
//       </div>

//       {state !== "idle" && (
//         <button
//           className="btn-add end-call"
//           onClick={() => {
//             setState("idle");
//             synth.cancel();
//             recognitionRef.current?.stop();
//             historyRef.current = [historyRef.current[0]]; // Reset memory
//           }}
//         >
//           <FaPhoneSlash /> End Call
//         </button>
//       )}
//     </div>
//   );
// }


// ----------------

import React, { useState, useEffect, useRef } from 'react';
import { FaPhoneSlash } from 'react-icons/fa';
import './voicebot.css';

export default function TalkingBot() {
  const [state, setState] = useState('idle');
  const recognitionRef = useRef(null);
  const synth = window.speechSynthesis;
  // Use a simple ref for messages to keep token usage low
  const messagesRef = useRef([
    { role: "system", content: `You are Hanna. Keep answers under 15 words. Focus on Cyfrowy.ai (Sif-rov-e dot AI) services. STOP speaking if interrupted.
             
              rules:  Start with a greeting, then wait for user input. If user asks about services, list them clearly. Always use the name Cyfrowy.ai. NEVER use any other name. NEVER talk about anything else outside of Cyfrowy.ai services. before ending, ask contact info for follow-up support. and end with greeting. ALWAYS follow the professional tone.
              
              OUR SERVICES:
            1. HR Agents: "HR Helpdesk", "Hiring Assistant", "Performance Review",
            2. Marketing Agents: "Content Creation", "Social Media Agent", "Ebook Generator",
            3. Sales Agents: "AI telecaller Agent", "Phone Dialer", "Proposal Writer",
            4. Banking Agents: "KYC Compliance", "Fraud Detection", "Loan Origination",
            5. Insurance Agents: "Policy Underwriting", "Claims Processing", "Claims Analysis",
            6. Others Agents: "RFP Creation", "IT Helpdesk", "Cloud Cost Analyzer"
            7. Real Estate Agents: "Property Valuation", "Tenant Screening", "Lease Management",

              ` }
  ]);

  const initRecognition = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    recognitionRef.current = new SpeechRecognition();
    recognitionRef.current.continuous = true;
    recognitionRef.current.interimResults = false;

    recognitionRef.current.onresult = (e) => {
      const transcript = e.results[e.results.length - 1][0].transcript;
      if (transcript) processUserIntent(transcript);
    };

    recognitionRef.current.onerror = (e) => {
      // Hard reset recognition if it crashes
      recognitionRef.current.stop();
      setTimeout(() => recognitionRef.current.start(), 1000);
    };
  };

  useEffect(() => {
    initRecognition();
    return () => { synth.cancel(); recognitionRef.current?.stop(); };
  }, []);

  const processUserIntent = async (userText) => {
    synth.cancel(); 
    setState('speaking');

    // CONTEXT WINDOW: Only keep the last 3 turns to save tokens
    if (messagesRef.current.length > 7) { 
        messagesRef.current = [messagesRef.current[0], ...messagesRef.current.slice(-6)];
    }
    
    messagesRef.current.push({ role: "user", content: userText });

    try {
      const response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
        method: "POST",
        headers: { 
          "Authorization": "Bearer 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", 
          "Content-Type": "application/json" 
        },
        body: JSON.stringify({
          model: "llama-3.1-8b-instant",
          messages: messagesRef.current,
          max_tokens: 150 // Strict limit to save tokens
        })
      });

      const data = await response.json();
      const reply = data.choices[0].message.content.replace(/Cyfrowy\.ai/gi, "Sif-rov-e dot AI");
      
      messagesRef.current.push({ role: "assistant", content: reply });
      
      const utterance = new SpeechSynthesisUtterance(reply);
      utterance.onend = () => {
        setState('listening');
        // REFRESH: Every 5 turns, reset recognition to prevent browser memory hang
        if (messagesRef.current.length % 10 === 0) {
            recognitionRef.current.stop();
            setTimeout(() => recognitionRef.current.start(), 500);
        }
      };
      synth.speak(utterance);
    } catch (e) {
      console.error(e);
      setState('listening');
    }
  };

  const startCall = () => {
    setState('listening');
    try { recognitionRef.current.start(); } catch(e) {}
    const greet = new SpeechSynthesisUtterance("Hello, I am Hanna from Sif-rov-e dot AI. How can I assist you?");
    synth.speak(greet);
  };

  return (
    <div className="live-demo-card">
      <div className={`ai-gif-container ${state}`} onClick={state === 'idle' ? startCall : null}>
        <img src="https://miro.medium.com/v2/resize:fit:1200/1*wX8RI80-FKhbP0ODlQrEQw.gif" className="ai-gif" alt="Hanna" />
      </div>
      {state !== 'idle' && (
        <button className="btn-add end-call" onClick={() => { 
          setState('idle'); 
          synth.cancel(); 
          recognitionRef.current.stop();
          messagesRef.current = [messagesRef.current[0]]; // Clear history on end
        }}><FaPhoneSlash /> End Call</button>
      )}
    </div>
  );
}